module.exports = function getTagIETFLanguageCode(tagIETF) {
  return tagIETF.split(/-|_/)[0];
};
